/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if
 * you want to be notified when the variant changes on product page, you can
 * attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific
 * product, you can trigger the event "cart:refresh" in a similar way (in that-
 * case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * You can also open or close the cart by triggering the event "cart:open" or
 * "cart:close" This will only open/close the cart and not refresh the contents
 * of the cart but you can chain these events by using async, await, and
 * setTimeout:
 *
 * document.body.dispatchEvent(new CustomEvent('cart:open', {
 *   bubbles: true
 * }));
 *
 * document.body.dispatchEvent(new CustomEvent('cart:close', {
 *   bubbles: true
 * }));
 */

/**
 * --------------------------------------------------------------------------
 * Enable pinch-to-zoom on all Flickity carousels
 * --------------------------------------------------------------------------
 * This global setting allows users to pinch-zoom images in galleries while
 * maintaining swipe navigation. Affects all Flickity instances site-wide.
 * Must run after Flickity is loaded but before initialization.
 */
(function () {
	function enablePinchZoom() {
		if (typeof Flickity !== "undefined") {
			Flickity.prototype._touchActionValue = "pan-y pinch-zoom";
			console.log("Flickity pinch-zoom enabled");
		} else {
			console.warn("Flickity not loaded yet, retrying...");
			setTimeout(enablePinchZoom, 50);
		}
	}
	enablePinchZoom();
})();

$(document).ready(function () {
	/**
	 * --------------------------------------------------------------------------
	 * Mobile image slider
	 * --------------------------------------------------------------------------
	 */
	function responseInitFlickity() {
		var mobile_ImageSlider = document.querySelectorAll(
			".ProductItem--collection .mobile_ImageSlider"
		);
		if (mobile_ImageSlider.length) {
			var windowWidth = window.innerWidth;
			if (windowWidth < 641) {
				for (var el of mobile_ImageSlider) {
					// Skip Flickity initialization for search results page
					if (el.closest(".template-search")) {
						continue;
					}

					var flkty = new Flickity(el, {
						cellAlign: "left",
						contain: true,
						wrapAround: false,
						prevNextButtons: true,
						dragThreshold: 10,
						pageDots: false,
						arrowShape: {
							x0: 10,
							x1: 45,
							y1: 50,
							x2: 55,
							y2: 50,
							x3: 20,
						},
					});
					flkty.resize();
				}
			}
		}
	}

	// Initial resize.
	responseInitFlickity();

	// Check again for new loaded elements with mobile image slider.
	$(window).on("load", ".mobile_ImageSlider", function () {
		responseInitFlickity();
	});

	const observer = new MutationObserver(function () {
		responseInitFlickity();
	});

	/*
	 * Product recommendations use the same snippet for rendering product items.
	 * On mobile, product items are using Flickity to display product images as a
	 * carousel. Since product recommendations uses AJAX to load content, the
	 * product recommendations container needs to be observed to properly resize
	 * product items with flickity carousels upon successfully loading the content
	 * to avoid stacked images.
	 */
	$(document).ready(function () {
		if ($(".ProductRecommendations").length) {
			observer.observe(document.querySelector(".ProductRecommendations"), {
				subtree: false,
				childList: true,
			});
		}
	});

	window.addEventListener("resize", responseInitFlickity);

	/**
	 * Initializes flickity on mobile image slider upon loading pagination
	 * content on collection pages.
	 * @see https://ajaxinate.elkfox.io/
	 */
	var endlessScroll = new Ajaxinate({
		container: "#AjaxinateContainer",
		pagination: "#AjaxinatePagination",
		loadingText: "Loading...",
		method: "click",
		offset: 1000,
		callback: function () {
			responseInitFlickity();
		},
	});

	const productList = document.querySelector(".CollectionInner__Products");

	if (productList) {
		// Prevent default behavior of pagination links, since Ajaxinate handles this.
		$(document).on("click", "#AjaxinatePagination > a", function (event) {
			event.preventDefault();
		});
	}

	// Reattach event listeners to pagination links after Ajaxinate loads new
	// content. Implemented for when users are changing the filters on collection
	// since products are loaded via AJAX.
	const productListObserver = new MutationObserver(function (event) {
		var endlessScroll = new Ajaxinate({
			container: "#AjaxinateContainer",
			pagination: "#AjaxinatePagination",
			loadingText: "Loading...",
			method: "click",
			offset: 1000,
			callback: function () {
				responseInitFlickity();
			},
		});
	});

	try {
		if (productList) {
			productListObserver.observe(productList, {
				subtree: false,
				childList: true,
			});
		}
	} catch (error) {
		console.warn(error);
	}

	/**
	 * --------------------------------------------------------------------------
	 * Accordions
	 * --------------------------------------------------------------------------
	 */
	let accordions = document.querySelectorAll(".acco_wrapper .acco_row_title");
	for (let accordion of accordions) {
		accordion.addEventListener("click", function (e) {
			e.preventDefault();

			e.target.classList.toggle("active");
			let container = e.target.nextElementSibling;
			$(container).slideToggle("fast");

			if (!container.classList.contains("active")) {
				container.classList.add("active");
			} else {
				container.classList.remove("active");
			}
		});
	}

	// focus email capture input on "keep in touch" click
	const keepInTouchHeader = document.querySelector(
		".Footer__NewsletterWrapper > h2"
	);
	const keepInTouchEmailInput = document.querySelector(
		".Footer__NewsletterWrapper input[type=email]"
	);

	keepInTouchHeader.addEventListener("click", (event) => {
		if (event.target.textContent.toLowerCase() === "keep in touch") {
			window.scrollTo({
				top: keepInTouchEmailInput.offsetTop,
				behavior: "smooth",
			});

			setTimeout(() => keepInTouchEmailInput.focus(), 200);
		}
	});
});

// Sticky Header
const header_el = document.querySelector("#shopify-section-header");
const header_wrapper_el = document.querySelector(".Header__Wrapper");
let pixels_from_top = header_el.getBoundingClientRect().top;

if (pixels_from_top < 0) {
	const store_switcher_el = document.querySelector(
		"#shopify-section-store-switcher"
	);
	const announcement_el = document.querySelector(
		"#shopify-section-announcement"
	);
	// dynamically calculate the pixels from top based on adding the heights of the these two elements
	let store_switcher_margin = parseInt(
		window.getComputedStyle(store_switcher_el).getPropertyValue("margin-bottom")
	);
	let announcement_margin = parseInt(
		window.getComputedStyle(announcement_el).getPropertyValue("margin-top")
	);

	pixels_from_top =
		store_switcher_el.offsetHeight +
		announcement_el.offsetHeight +
		store_switcher_margin +
		announcement_margin;
}

window.addEventListener("scroll", function () {
	if (window.pageYOffset >= pixels_from_top) {
		header_el.style.position = "fixed";
		header_wrapper_el.style.paddingTop = "10px";
		header_wrapper_el.style.paddingBottom = "10px";
		document.body.style.marginTop = header_el.offsetHeight + "px";
	} else if (window.pageYOffset < pixels_from_top) {
		header_el.style.position = "relative";
		header_wrapper_el.style.paddingTop = "";
		header_wrapper_el.style.paddingBottom = "";
		document.body.style.marginTop = 0;
	}
});
// END Sticky Header

/**
 * --------------------------------------------------------------------------
 * Minimal Cart Form Interceptor
 * --------------------------------------------------------------------------
 * Prevents cart forms from redirecting and converts them to AJAX with product:added events
 */
document.addEventListener("submit", function (event) {
	const form = event.target;

	// Only intercept forms that submit to /cart/add
	if (form.getAttribute("action") === "/cart/add") {
		// Skip theme-managed forms that already have AJAX handlers
		// But NOT search results or drawer forms which need our interceptor
		const isMainProductForm = form.closest(
			".Product__Form, .ProductForm__Wrapper"
		);
		const isCollectionPopover = form.classList.contains(
			"CollectionProductForm"
		);

		if (isMainProductForm || isCollectionPopover) {
			console.log(
				"Skipping theme-managed form (main product or collection popover)"
			);
			return;
		}

		console.log(
			"Intercepting cart form:",
			form.className || form.id || "unnamed form"
		);

		event.preventDefault();
		event.stopPropagation(); // Prevent parent onclick handlers

		const submitButton =
			form.querySelector('input[type="submit"], button[type="submit"]') ||
			form.querySelector("button") ||
			event.submitter;

		if (!submitButton) {
			console.error("No submit button found in form");
			return;
		}

		// Store original state
		const originalText = submitButton.textContent || submitButton.value;
		const isInputButton = submitButton.tagName.toLowerCase() === "input";

		// Show loading state
		submitButton.disabled = true;
		if (isInputButton) {
			submitButton.value = "Adding...";
		} else {
			submitButton.textContent = "Adding...";
		}

		// Serialize form data
		const formData = new FormData(form);
		const data = {};
		for (let [key, value] of formData.entries()) {
			data[key] = value;
		}

		// Make AJAX request
		const cartUrl = window.theme?.localeRootUrl
			? window.theme.localeRootUrl + "/cart/add.js"
			: "/cart/add.js";

		fetch(cartUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Requested-With": "XMLHttpRequest",
			},
			credentials: "same-origin",
			body: JSON.stringify(data),
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
				throw new Error("Cart addition failed");
			})
			.then((product) => {
				console.log("Product added to cart successfully:", product);

				// Restore button state
				submitButton.disabled = false;
				if (isInputButton) {
					submitButton.value = originalText;
				} else {
					submitButton.textContent = originalText;
				}

				// Trigger product:added event for theme compatibility
				document.documentElement.dispatchEvent(
					new CustomEvent("product:added", {
						bubbles: true,
						detail: {
							variant: {
								id: data.id,
								product_id: product.product_id,
								price: product.price,
							},
							quantity: parseInt(data.quantity || "1"),
							product: product,
						},
					})
				);

				// Trigger cart refresh to update mini-cart
				document.documentElement.dispatchEvent(
					new CustomEvent("cart:refresh", {
						bubbles: true,
					})
				);

				// Clear search input on successful add to cart
				const searchInput = document.querySelector('.Search__Input[name="q"]');
				if (searchInput && searchInput.value.trim()) {
					searchInput.value = "";
					console.log("Search input cleared after successful cart addition");
				}
			})
			.catch((error) => {
				console.error("Error adding to cart:", error);

				// Restore button state
				submitButton.disabled = false;
				if (isInputButton) {
					submitButton.value = originalText;
				} else {
					submitButton.textContent = originalText;
				}

				alert("Error adding item to cart. Please try again.");
			});
	}
});

/**
 * ----------------------------------------------------------------------------
 * Cart drawer "Did you forget" recommendation button handler
 * Uses click delegation to handle dynamically added buttons after cart refresh.
 * Note: Can't use form here because cart drawer is wrapped in checkout form (nested forms invalid)
 * ----------------------------------------------------------------------------
 */
document.addEventListener("click", function (event) {
	const button = event.target.closest(".js-add-recommendation");
	if (!button) return;

	event.preventDefault();

	const variantId = button.getAttribute("data-variant-id");
	if (!variantId) {
		console.error("No variant ID found on recommendation button");
		return;
	}

	// Store original state
	const originalHTML = button.innerHTML;

	// Show loading state
	button.disabled = true;
	button.innerHTML = "<span>Adding...</span>";

	const cartUrl = window.theme?.localeRootUrl
		? window.theme.localeRootUrl + "/cart/add.js"
		: "/cart/add.js";

	fetch(cartUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"X-Requested-With": "XMLHttpRequest",
		},
		credentials: "same-origin",
		body: JSON.stringify({ id: variantId, quantity: 1 }),
	})
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
			throw new Error("Cart addition failed");
		})
		.then((product) => {
			// Dispatch product:added event for theme compatibility
			document.documentElement.dispatchEvent(
				new CustomEvent("product:added", {
					bubbles: true,
					detail: {
						variant: {
							id: variantId,
							product_id: product.product_id,
							price: product.price,
						},
						quantity: 1,
						product: product,
					},
				})
			);

			// Trigger cart refresh
			document.documentElement.dispatchEvent(
				new CustomEvent("cart:refresh", { bubbles: true })
			);
		})
		.catch((error) => {
			console.error("Error adding recommendation to cart:", error);

			// Restore button state
			button.disabled = false;
			button.innerHTML = originalHTML;

			alert("Error adding item to cart. Please try again.");
		});
});

// Mobile Product Gallery Thumbnail Navigation
document.addEventListener("DOMContentLoaded", function () {
	// Only run on mobile/tablet devices
	if (window.innerWidth <= 1007) {
		const productGallery = document.querySelector(
			".Product__Gallery--withThumbnails"
		);

		if (productGallery) {
			const carousel = productGallery.querySelector(
				".Product__Slideshow.Carousel"
			);
			const thumbnailNav = productGallery.querySelector(
				".Product__SlideshowNav--thumbnails"
			);

			if (carousel && thumbnailNav) {
				// Wait for Flickity to initialize
				setTimeout(function () {
					const flkty = Flickity.data(carousel);

					if (flkty) {
						const thumbnails = thumbnailNav.querySelectorAll(
							".Product__SlideshowNavImage"
						);

						// Handle thumbnail clicks
						thumbnails.forEach(function (thumbnail, index) {
							thumbnail.addEventListener("click", function (e) {
								e.preventDefault();
								// Find the actual slide index (accounting for hidden slides)
								const targetImageId = thumbnail.getAttribute("data-image-id");
								const slides = carousel.querySelectorAll(".Product__SlideItem");

								let targetIndex = 0;
								slides.forEach(function (slide, slideIndex) {
									if (slide.getAttribute("data-image-id") === targetImageId) {
										targetIndex = slideIndex;
									}
								});

								// Navigate to the selected slide
								flkty.select(targetIndex);
							});
						});

						// Update thumbnail selection on slide change
						flkty.on("select", function () {
							const selectedSlide = carousel.querySelector(
								".Product__SlideItem.is-selected"
							);
							if (selectedSlide) {
								const selectedImageId =
									selectedSlide.getAttribute("data-image-id");

								// Update thumbnail selection
								thumbnails.forEach(function (thumbnail) {
									if (
										thumbnail.getAttribute("data-image-id") === selectedImageId
									) {
										thumbnail.classList.add("is-selected");

										// Scroll thumbnail into view if needed
										const navScroller = thumbnailNav.querySelector(
											".Product__SlideshowNavScroller"
										);
										if (navScroller) {
											const scrollLeft =
												thumbnail.offsetLeft -
												navScroller.offsetWidth / 2 +
												thumbnail.offsetWidth / 2;
											navScroller.scrollTo({
												left: scrollLeft,
												behavior: "smooth",
											});
										}
									} else {
										thumbnail.classList.remove("is-selected");
									}
								});
							}
						});

						// Set initial selection
						const initialSlide = carousel.querySelector(
							".Product__SlideItem.is-selected"
						);
						if (initialSlide) {
							const initialImageId = initialSlide.getAttribute("data-image-id");
							thumbnails.forEach(function (thumbnail) {
								if (
									thumbnail.getAttribute("data-image-id") === initialImageId
								) {
									thumbnail.classList.add("is-selected");
								}
							});
						}
					}
				}, 500);
			}
		}
	}
});
